import { render, staticRenderFns } from "./ScrollArrowRight.vue?vue&type=template&id=15c6d420&"
import script from "./ScrollArrowRight.vue?vue&type=script&lang=js&"
export * from "./ScrollArrowRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports